module.exports = __webpack_public_path__ + "static/media/preventivo_rojo.47749414.svg";